import React, { useEffect } from "react";
import Stack from 'react-bootstrap/Stack'
import PayeeSelection from './PayeeSelection';
import OMSMailIndicator from './OMSMailIndicator';
import WorklistIndicator from './WorklistIndicator';
import { useAuth } from '../context/AuthContext';
import { useOMS } from '../context/OMSContext';
import '../styles/Avatar.css';
import { Link } from 'react-router-dom';
import RoleUtils from '../utils/roleUtils.js';
import CommonUtils from '../utils/siteUtils.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faArrowRightFromBracket, /*faRectangleList, faRotateRight, faEnvelope*/ } from '@fortawesome/free-solid-svg-icons';

export const Avatar = (props) => {

    const { authObj, login, logout } = useAuth();
    const { omsObj, refreshWidget, disposeWidget } = useOMS();

    const getUserName = function () {
        var fn = "";
        var ln = "";
        var isInternal = false;
        if (authObj.claimsArr) {
            fn = (authObj.claimsArr.FirstName) ? authObj.claimsArr.FirstName : " - ";
            ln = (authObj.claimsArr.LastName) ? authObj.claimsArr.LastName : " - ";
            isInternal = (authObj.claimsArr.isInternal) ? authObj.claimsArr.isInternal : false;

            const maxLength = 15;
            const truncatedFn = fn.length > maxLength ? fn.substring(0, maxLength) + "..." : fn;
            const truncatedLn = ln.length > maxLength ? ln.substring(0, maxLength) + "..." : ln;
            const fullName = truncatedFn + " " + truncatedLn;
            //const nameElement = { fullName }; 

            return (isInternal === "true") ? <div className="avatarNameDisplay"><strong>Welcome, {fullName}</strong></div> : <div className="avatarNameDisplay">Welcome, {fullName}</div>;
        }
        else {
            return <span>Come on in</span>;
        }
    }

    const getRole = function () {
        var roleArr = RoleUtils.getCurrentRoles(authObj.userObj, props.currentCompanyId);
        switch (roleArr.length) {
            case 0:
                return (<div className="avatarRoleDisplay">&nbsp;</div>);
            case 1:
                return (<div className="avatarRoleDisplay">{roleArr[0]}</div>);
            default:
                //more than 1 role - if user has an Admin role, display that
                var adminRoles = roleArr.filter(r => r.toUpperCase().includes("ADMIN"));
                var multiRole = (adminRoles.length > 0) ? adminRoles[0] : ""; //6-22 DE732337 Remove Multiple Roles

                return (<div className="avatarRoleDisplay">{multiRole}</div>);
        }
    }
    const signoutApp = function () {
        //Remove OMS Session Item
        sessionStorage.removeItem("curSignInTime");
        disposeWidget();
        logout();
    }
    const buildMessageIndicator = function () {
        //if (omsObj.hasRendered) {
        return (<OMSMailIndicator omsObj={omsObj} refreshOMSWidget={refreshWidget} disposeWidget={disposeWidget} />);
        // }
        // else {
        //     return (<></>)
        // }
    }
    const buildWorklistIcon = function () {
        const { currentUser, currentCompanyId } = props;
        var wlTest = RoleUtils.determineMaintenanceModeNav(currentUser, currentCompanyId, RoleUtils.worklistPageAccessRoles());

        return (
            (wlTest)
                ? <WorklistIndicator currentUser={authObj.userObj} currentCompanyId={props.currentCompanyId} />
                : <></>
        );
    }


    useEffect(() => {
        if (!omsObj.hasRendered) {
            refreshWidget();
        }
    });

    return (
        (!authObj.isLoading) ?
            <Stack id="avatarBlock" direction="vertical">
                <div className="avatarItem">
                    {getUserName()}
                    <div className="avatarItem right homeLink">
                        <Link to="/" title="Home">
                            <button title="Home" className="avatar-masthead-button">
                                <FontAwesomeIcon id="font-awesome-home" size="4x" icon={faHome} />
                            </button>
                        </Link>
                    </div>
                </div>
                <div className="avatarItem">
                    {authObj.isAuthenticated &&
                        <PayeeSelection currentUser={authObj.userObj} isAuthenticated={authObj.isAuthenticated} isLoading={authObj.isLoading} onCompanyChange={props.onCompanyChange} />
                    }
                </div>
                <div className="avatarItem">

                    {!authObj.isAuthenticated &&
                        /*<p><a className="avatarItem" href="#" onClick={login} alt="Sign into site">Login</a></p>*/
                        <p className="authLink" onClick={login} alt="Sign into site">Sign In</p>
                    }
                    {authObj.isAuthenticated &&
                        <>
                            { /*<p id="log-out-link" onClick={logout}>Log Out</p> REMOVED: style={{ marginRight: "0px" }}   */}
                            <button title="Sign Out" className="avatar-masthead-button right" onClick={signoutApp}>
                                <FontAwesomeIcon id="font-awesome-logout" size="4x" icon={faArrowRightFromBracket} />
                            </button>
                            <div id="masthead-buttons">
                                {/*<Link to="/Inbox" title="Contact Payment Services">*/}
                                {/*    <button title="Inbox" className="avatar-masthead-button">*/}
                                {/*        <span className="fa-layers fa-3x fa-fw">*/}
                                {/*            <FontAwesomeIcon id="font-awesome-inbox" icon={faEnvelope} />*/}
                                {/*            <span id="inboxCounter" className="fa-layers-counter" data-fa-transform="shrink-11 down-4.2 left-4">5</span>*/}
                                {/*        </span>*/}
                                {/*    </button>*/}
                                {/*</Link>*/}
                                {buildMessageIndicator()}
                                {/*<Link to="/Worklist" title="View Worklist">*/}
                                {/*    <button title="Worklist" className="avatar-masthead-button">*/}
                                {/*        <FontAwesomeIcon id="font-awesome-home" size="4x" icon={faRectangleList} />*/}
                                {/*    </button>*/}
                                {/*</Link>*/}
                                {buildWorklistIcon()}
                                {getRole()}
                            </div>
                        </>
                    }
                    {/*END HOME & INBOXS BUTTON ON MASTHEAD*/}
                </div>
            </Stack>
            :
            <div className="avatarItem center">
                {/*   <p> <a className="avatarItem" href="#" onClick={login}>Sign In</a></p>*/}
                <p className="authLink" onClick={login} alt="Sign into site">Sign In</p>
            </div>
    );

}
